export default "__VITE_ASSET__DEFAb2B9__"